import { render, staticRenderFns } from "./NewDiscount.vue?vue&type=template&id=4b808974&scoped=true&"
import script from "./NewDiscount.vue?vue&type=script&lang=js&"
export * from "./NewDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b808974",
  null
  
)

export default component.exports